import React from 'react';
import { CheckoutConfig } from '../../../types';

interface FlowTabProps {
  config: CheckoutConfig;
  onUpdate: (partial: Partial<CheckoutConfig>) => void;
}

export const CheckoutStudioFlowTab: React.FC<FlowTabProps> = ({ config, onUpdate }) => {
  const recovery = config.recoveryConfig || {
    isEnabled: true,
    abandonmentThresholdMin: 15,
    delayHours: 2,
    automatedSequence: true,
    templateId: 'tpl_cart_recovery',
  };

  const handleRecoveryChange = (key: string, val: any) => {
    onUpdate({ recoveryConfig: { ...recovery, [key]: val } });
  };

  return (
    <div className="space-y-4 text-left">
      {/* Checkout Step Mode */}
      <div className="p-3.5 bg-slate-50 dark:bg-slate-900/60 rounded-xl border border-slate-200/80 dark:border-slate-800 space-y-3">
        <p className="text-xs font-bold text-slate-800 dark:text-slate-200">Checkout Funnel Flow</p>
        <div className="grid grid-cols-2 gap-2">
          <button
            type="button"
            onClick={() => onUpdate({ useMultiStep: false })}
            className={`p-3 rounded-xl border text-left transition-all ${
              !config.useMultiStep
                ? 'border-indigo-600 bg-indigo-50/50 dark:bg-indigo-950/30'
                : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800'
            }`}
          >
            <p className="text-xs font-bold text-slate-900 dark:text-white">1-Step Fast Flow</p>
            <p className="text-[10px] text-slate-500 mt-0.5">Details and payment on a single high-conversion view.</p>
          </button>

          <button
            type="button"
            onClick={() => onUpdate({ useMultiStep: true })}
            className={`p-3 rounded-xl border text-left transition-all ${
              config.useMultiStep
                ? 'border-indigo-600 bg-indigo-50/50 dark:bg-indigo-950/30'
                : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800'
            }`}
          >
            <p className="text-xs font-bold text-slate-900 dark:text-white">2-Step Guided Funnel</p>
            <p className="text-[10px] text-slate-500 mt-0.5">Captures customer details prior to gateway auth.</p>
          </button>
        </div>
      </div>

      {/* Cart Abandonment Capture */}
      <div className="p-3.5 bg-slate-50 dark:bg-slate-900/60 rounded-xl border border-slate-200/80 dark:border-slate-800 space-y-3">
        <label className="flex items-center justify-between p-2.5 bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 cursor-pointer">
          <div>
            <p className="text-xs font-bold text-slate-900 dark:text-white">Automatic Abandonment Capture</p>
            <p className="text-[11px] text-slate-500">Saves lead when customer submits email before payment.</p>
          </div>
          <input
            type="checkbox"
            checked={Boolean(recovery.isEnabled)}
            onChange={(e) => handleRecoveryChange('isEnabled', e.target.checked)}
            className="rounded text-indigo-600 focus:ring-indigo-500 w-4 h-4"
          />
        </label>

        {recovery.isEnabled && (
          <div className="grid grid-cols-2 gap-3 pt-1">
            <div>
              <label className="text-[10px] font-bold text-slate-500 uppercase">Abandonment Timeout (Min)</label>
              <input
                type="number"
                value={recovery.abandonmentThresholdMin}
                onChange={(e) => handleRecoveryChange('abandonmentThresholdMin', Number(e.target.value))}
                className="w-full text-xs font-bold px-3 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg outline-none"
              />
            </div>
            <div>
              <label className="text-[10px] font-bold text-slate-500 uppercase">Recovery Email Delay (Hours)</label>
              <input
                type="number"
                value={recovery.delayHours}
                onChange={(e) => handleRecoveryChange('delayHours', Number(e.target.value))}
                className="w-full text-xs font-bold px-3 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg outline-none"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
